import { useMemo } from 'react';

import { ToggleButton } from '../../../../buttons';
import { CastCopilot } from '../../../../icons';
import { Tooltip } from '../../../../tooltip';
import { tokens } from '../../../../../theme/generated/tokens';

export type ChartAnalyzeButtonProps = {
  getPrompt: (zoomedRange?: { from: number; to: number }) => string | null;
  onClick: (prompt: string) => void;
  disabled?: boolean;
  zoomedRange?: { from: number; to: number };
  testId?: string;
};

export const ChartAnalyzeButton = ({
  getPrompt,
  onClick,
  disabled,
  zoomedRange,
  testId = 'chart-analyze-with-opspilot',
}: ChartAnalyzeButtonProps) => {
  const prompt = useMemo(() => {
    if (zoomedRange?.from == null || zoomedRange?.to == null) {
      return getPrompt(undefined);
    }
    return getPrompt({
      from: zoomedRange.from,
      to: zoomedRange.to,
    });
  }, [getPrompt, zoomedRange?.from, zoomedRange?.to]);

  const isDisabled = disabled || !prompt;

  const handleClick = () => {
    if (prompt) {
      onClick(prompt);
    }
  };

  return (
    <Tooltip
      title="Analyze this data with OpsPilot"
      placement="bottom-end"
      arrow={false}
    >
      <div data-testid={testId}>
        <ToggleButton
          value="analyze"
          icon={
            <CastCopilot
              color={tokens.theme.fg.structural.secondary}
              size={20}
            />
          }
          onClick={handleClick}
          disabled={isDisabled}
          testId={testId}
        />
      </div>
    </Tooltip>
  );
};
